import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';

const breadcrumb = [
  { label: 'Accueil', to: '/' },
  { label: 'Politique de confidentialité' },
];

export default function PolitiqueConfidentialite() {
  return (
    <>
      <SEO
        title="Politique de confidentialité | DFPRO Hérault"
        description="Politique de confidentialité et protection des données personnelles. DFPRO Hérault s'engage à protéger vos données conformément au RGPD."
        canonicalUrl="https://heraultroulettesbaiesvitrees.fr/politique-de-confidentialite/"
      />
      <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden">
        <img
          src="/images/dfpro-legal-hero.jpg"
          alt="Politique de confidentialité DFPRO Hérault"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/75"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumb} light />
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-white mt-4">
            Politique de confidentialité
          </h1>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <article className="prose prose-lg max-w-none font-body text-foreground-500">
            <h2>1. Collecte des données personnelles</h2>
            <p>
              Dans le cadre de son activité de réparation de menuiseries, DFPRO Hérault (DF PRO) est amenée à collecter des données personnelles vous concernant. Ces données sont collectées lorsque vous utilisez notre formulaire de contact, nous appelez par téléphone ou nous envoyez un email. Les informations collectées peuvent inclure votre nom, prénom, adresse email, numéro de téléphone, adresse postale, ainsi que toute information relative à votre demande de devis ou d'intervention.
            </p>

            <h2>2. Finalité du traitement</h2>
            <p>
              Les données personnelles collectées sont utilisées exclusivement pour :
            </p>
            <ul>
              <li>Répondre à vos demandes de devis et de renseignements</li>
              <li>Organiser et planifier les interventions de nos techniciens</li>
              <li>Assurer le suivi de nos prestations et de la garantie décennale</li>
              <li>Respecter nos obligations légales et comptables</li>
            </ul>
            <p>
              En aucun cas vos données personnelles ne sont vendues, louées ou cédées à des tiers à des fins commerciales.
            </p>

            <h2>3. Base légale du traitement</h2>
            <p>
              Le traitement de vos données personnelles est fondé sur :
            </p>
            <ul>
              <li>Votre consentement, pour les demandes de contact et de devis</li>
              <li>L'exécution d'un contrat, pour la réalisation de nos prestations de réparation</li>
              <li>Le respect d'obligations légales, notamment comptables et fiscales</li>
            </ul>

            <h2>4. Destinataires des données</h2>
            <p>
              Les données collectées sont destinées aux services internes de DF PRO habilités à les traiter dans le cadre de leurs fonctions. Elles peuvent être communiquées à nos sous-traitants techniques (hébergeur, prestataire de formulaire de contact) dans la stricte mesure nécessaire à l'exécution de leurs missions.
            </p>

            <h2>5. Durée de conservation</h2>
            <p>
              Vos données personnelles sont conservées pendant la durée nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées :
            </p>
            <ul>
              <li>Données de contact et demandes de devis : 3 ans à compter du dernier contact</li>
              <li>Données liées aux interventions et à la garantie : 10 ans (durée de la garantie décennale)</li>
              <li>Données comptables : 10 ans (obligation légale)</li>
            </ul>

            <h2>6. Vos droits</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants sur vos données personnelles :
            </p>
            <ul>
              <li><strong>Droit d'accès :</strong> obtenir la confirmation que vos données sont traitées et en obtenir une copie</li>
              <li><strong>Droit de rectification :</strong> faire corriger des données inexactes ou incomplètes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données dans les conditions prévues par la loi</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données pour des motifs légitimes</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit à la limitation du traitement :</strong> demander la suspension temporaire du traitement</li>
            </ul>
            <p>
              Pour exercer ces droits, contactez-nous par email à <a href="mailto:herault@dfpro.fr" className="text-accent-500 hover:underline">herault@dfpro.fr</a> ou par courrier à : DF PRO, 100 route de Nîmes, 30132 Caissargues, France. Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr).
            </p>

            <h2>7. Cookies</h2>
            <p>
              Le site <strong>heraultroulettesbaiesvitrees.fr</strong> n'utilise pas de cookies de suivi publicitaire ou d'analyse d'audience. Seuls des cookies techniques strictement nécessaires au fonctionnement du site peuvent être déposés sur votre navigateur.
            </p>

            <h2>8. Sécurité</h2>
            <p>
              DF PRO met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre la destruction accidentelle ou illicite, la perte, l'altération, la divulgation ou l'accès non autorisé.
            </p>

            <h2>9. Modification de la politique</h2>
            <p>
              DF PRO se réserve le droit de modifier la présente politique de confidentialité à tout moment. La version la plus récente sera toujours disponible sur cette page. Nous vous invitons à la consulter régulièrement.
            </p>

            <p className="text-sm text-secondary-500 mt-8">
              Dernière mise à jour : juillet 2026
            </p>
          </article>
        </div>
      </section>
    </>
  );
}